/// <reference path="../types/index.d.ts" />

import '../client_forms/bingemanscc2/style.css';
import FormStructure from './bingemanscc2/form_structure';

export default FormStructure;